import React, { PropTypes } from 'react';
import styled from 'styled-components';
import { NitroButton, NitroButtonGroup, NitroText } from 'nitro-components';

const Section = styled.section`
  padding: 60px 0;
  text-align: center;
`;

const Title = styled(NitroText)`
  display: block;
  margin-bottom: 40px;
`;

const DashboardNoCurrentLeases = ({
  showHistoryDetails,
  handleAllocation,
  dashboardType,
}) => {
  return (
    <Section>
      <Title
        bold
        size={2}
        variant="secondary"
      >
        {dashboardType === 'driver' ?
          'This driver currently has no allocated vehicles' : 'This vehicle currently has no allocated drivers'
        }
      </Title>
      <div>
        <NitroButtonGroup layout="horizontal" align="center">
          <NitroButton
            action={showHistoryDetails}
            icon="recent"
            label={`SEE ${dashboardType === 'driver' ? 'VEHICLE' : 'DRIVER'} HISTORY`}
          />
          <NitroButton
            action={handleAllocation}
            icon="car"
            label={`ALLOCATE A ${dashboardType === 'driver' ? 'VEHICLE' : 'DRIVER'}`}
            variant="primary"
          />
        </NitroButtonGroup>
      </div>
    </Section>
  );
};

DashboardNoCurrentLeases.propTypes = {
  handleAllocation: PropTypes.func.isRequired,
  showHistoryDetails: PropTypes.func.isRequired,
  dashboardType: PropTypes.string,
};

export default DashboardNoCurrentLeases;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/DashboardNoCurrentLeases.js